import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '福利分类',
    links: [
      { label: '优惠券', href: '/category/coupon' },
      { label: '折扣活动', href: '/category/discount' },
      { label: '会员福利', href: '/category/member' },
      { label: '返利信息', href: '/category/rebate' },
      { label: '限时特惠', href: '/category/flash' },
    ],
  },
  {
    title: '热门文章',
    links: [
      { label: '优惠券领取攻略', href: '/article/a1' },
      { label: '会员福利大盘点', href: '/article/a2' },
      { label: '返利平台评测', href: '/article/a3' },
      { label: '限时秒杀技巧', href: '/article/a4' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '用户口碑', href: '/about#testimonials' },
      { label: '联系方式', href: '/about#contact' },
      { label: '常见问题', href: '/#faq' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-gift-line text-xl text-white"></i>
              </div>
              <span className="text-xl font-bold font-heading text-white">福利导航网</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              一站式福利资源聚合平台，汇集海量优惠券、折扣活动、会员福利、返利信息及限时特惠，省钱省时更省心。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-sm text-white"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-sm text-white"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors" aria-label="邮箱">
                <i className="ri-mail-line text-sm text-white"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-white mb-4">{section.title}</h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-400 hover:text-primary-300 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 福利导航网 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-6">
            <Link to="/about" className="text-xs text-background-500 hover:text-primary-300 transition-colors">关于我们</Link>
            <a href="#" className="text-xs text-background-500 hover:text-primary-300 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-300 transition-colors" rel="nofollow">用户协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}